import { Icon, IconProps } from "../icon";
import { ComponentPropsWithoutRef, forwardRef } from "react";
import { cn } from "@utils";

type IconButtonProps = {
  icon: IconProps["variant"];
  iconSize: IconProps["size"];
  isActive?: boolean;
};

export const IconButton = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<"button"> & IconButtonProps
>((props, forwardedRef) => {
  const {
    iconSize,
    icon,
    className,
    isActive = false,
    type,
    ...buttonProps
  } = props;
  return (
    <button
      {...buttonProps}
      className={cn(className, "c-icon-button has-focus-visible-ring", {
        "is-active": isActive,
      })}
      ref={forwardedRef}
      type={type || "button"}
    >
      <Icon size={iconSize} variant={icon} />
    </button>
  );
});

IconButton.displayName = "IconButton";
